import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { DateFormatService } from 'dmmp-services'

@Component({
  selector: 'dmmp-event-view',
  templateUrl: './event-view.component.html'
})
export class EventViewComponent implements OnInit {

  @Input() eventInfo
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()

  constructor(private dateFormatServices: DateFormatService) { }

  ngOnInit(): void {
    this.eventInfo.date.start = this.dateFormatServices.convertFromTimestampToDate(this.eventInfo?.date?.start)
  }

}
